"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DOMException = require("domexception/webidl2js-wrapper");
var HTMLElementImpl = require("./HTMLElement-impl").implementation;
var _require = require("../helpers/namespaces"),
  HTML_NS = _require.HTML_NS;
var _require2 = require("../helpers/internal-constants"),
  domSymbolTree = _require2.domSymbolTree;
var _require3 = require("../helpers/traversal"),
  firstChildWithLocalName = _require3.firstChildWithLocalName,
  childrenByLocalName = _require3.childrenByLocalName;
var HTMLCollection = require("../generated/HTMLCollection");
var NODE_TYPE = require("../node-type");
function tHeadInsertionPoint(table) {
  var iterator = domSymbolTree.childrenIterator(table);
  var _iterator = _createForOfIteratorHelper(iterator),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;
      if (child.nodeType !== NODE_TYPE.ELEMENT_NODE) {
        continue;
      }
      if (child._namespaceURI !== HTML_NS || child._localName !== "caption" && child._localName !== "colgroup") {
        return child;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
var HTMLTableElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLTableElementImpl, _HTMLElementImpl);
  var _super = _createSuper(HTMLTableElementImpl);
  function HTMLTableElementImpl() {
    _classCallCheck(this, HTMLTableElementImpl);
    return _super.apply(this, arguments);
  }
  _createClass(HTMLTableElementImpl, [{
    key: "caption",
    get: function get() {
      return firstChildWithLocalName(this, "caption");
    },
    set: function set(value) {
      var currentCaption = this.caption;
      if (currentCaption !== null) {
        this.removeChild(currentCaption);
      }
      if (value !== null) {
        var insertionPoint = this.firstChild;
        this.insertBefore(value, insertionPoint);
      }
    }
  }, {
    key: "tHead",
    get: function get() {
      return firstChildWithLocalName(this, "thead");
    },
    set: function set(value) {
      if (value !== null && value._localName !== "thead") {
        throw DOMException.create(this._globalObject, ["Cannot set a non-thead element as a table header", "HierarchyRequestError"]);
      }
      var currentHead = this.tHead;
      if (currentHead !== null) {
        this.removeChild(currentHead);
      }
      if (value !== null) {
        var insertionPoint = tHeadInsertionPoint(this);
        this.insertBefore(value, insertionPoint);
      }
    }
  }, {
    key: "tFoot",
    get: function get() {
      return firstChildWithLocalName(this, "tfoot");
    },
    set: function set(value) {
      if (value !== null && value._localName !== "tfoot") {
        throw DOMException.create(this._globalObject, ["Cannot set a non-tfoot element as a table footer", "HierarchyRequestError"]);
      }
      var currentFoot = this.tFoot;
      if (currentFoot !== null) {
        this.removeChild(currentFoot);
      }
      if (value !== null) {
        this.appendChild(value);
      }
    }
  }, {
    key: "rows",
    get: function get() {
      var _this = this;
      if (!this._rows) {
        this._rows = HTMLCollection.createImpl(this._globalObject, [], {
          element: this,
          query: function query() {
            var headerRows = [];
            var bodyRows = [];
            var footerRows = [];
            var iterator = domSymbolTree.childrenIterator(_this);
            var _iterator2 = _createForOfIteratorHelper(iterator),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var child = _step2.value;
                if (child.nodeType !== NODE_TYPE.ELEMENT_NODE || child._namespaceURI !== HTML_NS) {
                  continue;
                }
                if (child._localName === "thead") {
                  headerRows.push.apply(headerRows, _toConsumableArray(childrenByLocalName(child, "tr")));
                } else if (child._localName === "tbody") {
                  bodyRows.push.apply(bodyRows, _toConsumableArray(childrenByLocalName(child, "tr")));
                } else if (child._localName === "tfoot") {
                  footerRows.push.apply(footerRows, _toConsumableArray(childrenByLocalName(child, "tr")));
                } else if (child._localName === "tr") {
                  bodyRows.push(child);
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            return [].concat(headerRows, bodyRows, footerRows);
          }
        });
      }
      return this._rows;
    }
  }, {
    key: "tBodies",
    get: function get() {
      var _this2 = this;
      if (!this._tBodies) {
        this._tBodies = HTMLCollection.createImpl(this._globalObject, [], {
          element: this,
          query: function query() {
            return childrenByLocalName(_this2, "tbody");
          }
        });
      }
      return this._tBodies;
    }
  }, {
    key: "createTBody",
    value: function createTBody() {
      var el = this._ownerDocument.createElement("TBODY");
      var tbodies = childrenByLocalName(this, "tbody");
      var insertionPoint = tbodies[tbodies.length - 1];
      if (insertionPoint) {
        this.insertBefore(el, insertionPoint.nextSibling);
      } else {
        this.appendChild(el);
      }
      return el;
    }
  }, {
    key: "createTHead",
    value: function createTHead() {
      var el = this.tHead;
      if (!el) {
        el = this.tHead = this._ownerDocument.createElement("THEAD");
      }
      return el;
    }
  }, {
    key: "deleteTHead",
    value: function deleteTHead() {
      this.tHead = null;
    }
  }, {
    key: "createTFoot",
    value: function createTFoot() {
      var el = this.tFoot;
      if (!el) {
        el = this.tFoot = this._ownerDocument.createElement("TFOOT");
      }
      return el;
    }
  }, {
    key: "deleteTFoot",
    value: function deleteTFoot() {
      this.tFoot = null;
    }
  }, {
    key: "createCaption",
    value: function createCaption() {
      var el = this.caption;
      if (!el) {
        el = this.caption = this._ownerDocument.createElement("CAPTION");
      }
      return el;
    }
  }, {
    key: "deleteCaption",
    value: function deleteCaption() {
      var c = this.caption;
      if (c) {
        c.parentNode.removeChild(c);
      }
    }
  }, {
    key: "insertRow",
    value: function insertRow(index) {
      if (index < -1 || index > this.rows.length) {
        throw DOMException.create(this._globalObject, ["Cannot insert a row at an index that is less than -1 or greater than the number of existing rows", "IndexSizeError"]);
      }
      var tr = this._ownerDocument.createElement("tr");
      if (this.rows.length === 0 && this.tBodies.length === 0) {
        var tBody = this._ownerDocument.createElement("tbody");
        tBody.appendChild(tr);
        this.appendChild(tBody);
      } else if (this.rows.length === 0) {
        var _tBody = this.tBodies.item(this.tBodies.length - 1);
        _tBody.appendChild(tr);
      } else if (index === -1 || index === this.rows.length) {
        var tSection = this.rows.item(this.rows.length - 1).parentNode;
        tSection.appendChild(tr);
      } else {
        var beforeTR = this.rows.item(index);
        var _tSection = beforeTR.parentNode;
        _tSection.insertBefore(tr, beforeTR);
      }
      return tr;
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(index) {
      var rowLength = this.rows.length;
      if (index < -1 || index >= rowLength) {
        throw DOMException.create(this._globalObject, ["Cannot delete a row at index ".concat(index, ", where no row exists"), "IndexSizeError"]);
      }
      if (index === -1) {
        if (rowLength === 0) {
          return;
        }
        index = rowLength - 1;
      }
      var tr = this.rows.item(index);
      tr.parentNode.removeChild(tr);
    }
  }]);
  return HTMLTableElementImpl;
}(HTMLElementImpl);
module.exports = {
  implementation: HTMLTableElementImpl
};